import request from '@/utils/request'

// 获取货车列表
export function getList(params) {
  return request.get('/truckInfo/list', { params })
}

// 创建货车信息
export function createOne(data) {
  return request.post('/truckInfo/create', data)
}

// 更新货车信息
export function updateOne(data) {
  return request.post('/truckInfo/update', data)
}

// 删除货车信息
export function deleteOne(data) {
  const url = '/truckInfo/delete/' + data.id
  return request.get(url)
}

// 一键签退
export function unbindAll(data) {
  return request.get('/truckInfo/unbound')
}

// 司机签到
export function bindOne(data) {
  const { driver, ...params } = data
  return request.get('/truckInfo/bindTruck', {
    params: {
      ...params,
      name: driver
    }
  })
}

// 司机签退
export function unbindOne(data) {
  const { driver, ...params } = data
  return request.get('/truckInfo/unboundTruck', {
    params: {
      ...params,
      name: driver
    }
  })
}
